<template>
  <v-card class="v-card--no-style mt-8">
    <div class="v-card-h1 mt-6">Obiekty</div>

    <v-card flat class="mt-6">
      <div v-for="(place, index) in places" :key="index" class="v-card__item">
        <div class="v-card-h2 mb-1">
          <a :href="websiteUrl + place.id">{{ place.name }}</a>
        </div>

        <ul class="tags-container tags-container--row mb-3 px-0">
          <li class="tag">
            <v-icon mr-4>mdi-map-marker</v-icon>

            <p class="sr-only">Lokalizacja:</p>

            <p>{{ address(place) }}</p>
          </li>

          <li v-if="place.phoneNumber" class="tag">
            <v-icon mr-4>mdi-phone</v-icon>

            <p class="sr-only">Numer telefonu:</p>

            <p>{{ place.phoneNumber }}</p>
          </li>
        </ul>
      </div>
    </v-card>
  </v-card>
</template>

<script>
import { address } from '@witkac/kartamiejska-shared';

import { mediaMixin } from '@/mixins/media';
import { imagesMixin } from '@/mixins/images';
import { config } from '@/utils/config';

// @vuese
// Lista obiektów partnera
// @group Partner
export default {
  mixins: [mediaMixin, imagesMixin],
  props: {
    // Obiekty
    places: {
      type: Array,
      required: true
    }
  },
  computed: {
    websiteUrl() {
      const webAdress = config.publicSiteUrl?.endsWith('/')
        ? config.publicSiteUrl + 'Obiekty/'
        : config.publicSiteUrl + '/Obiekty/';
      if (webAdress.match(/^https?:\/\//gi)) {
        return webAdress;
      }
      return 'http://' + webAdress;
    }
  },
  methods: {
    // @vuese
    // Filtr adresu
    address
  }
};
</script>

<style>
.v-image__image--preload {
  filter: none !important;
}
</style>
